import Button from "@mui/material/Button/Button";
import React, { useCallback, useRef } from "react";
import Webcam from "react-webcam";
import styles from "./RtsScanModule.styles";
import RtsScanStore from "./RtsScanStore";

interface CameraComponentProps {
  onClose: any;
  onSubmit: any;
}

const CameraComponent: React.FC<CameraComponentProps> = ({
  onClose,
  onSubmit,
}) => {
  let imageUploadWebcamRef = useRef<Webcam>(null);

  const { setLatestImage } = RtsScanStore();

  const capture = useCallback(() => {
    const imageSrc = imageUploadWebcamRef.current?.getScreenshot();
    if (imageSrc) {
      setLatestImage(imageSrc);
    }
  }, [imageUploadWebcamRef]);

  return (
    <>
      <Webcam
        audio={false}
        width="100%"
        height="100%"
        ref={imageUploadWebcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={{
          width: 500,
          height: 360,
          facingMode: "environment",
        }}
      />
      <div style={styles.manualEntryModuleButtons}>
        <Button style={styles.buttonItem} variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          style={styles.buttonItem}
          variant="contained"
          onClick={() => {
            capture();
            onSubmit();
          }}
        >
          Capture
        </Button>
      </div>
    </>
  );
};
export default CameraComponent;
